import React, { useState, useEffect } from 'react';
import StickyBox from 'react-sticky-box';

import classNames from 'classnames';
import jsCookie from 'js-cookie';

import styles from './PostV2.module.scss';

import PostAuthor from '../../PostAuthor/PostAuthor';
import PostCategory from '../../PostCategory/PostCategory';
import Divider from '../../Divider/Divider';
import ReadingTime from '../../ReadingTime/ReadingTime';
import PostDate from '../../PostDate/PostDate';
import SocialShare from '../../SocialShare/SocialShare';
import PostTag from '../../PostTag/PostTag';
import RelatedPostV2 from '../../Widget/RelatedPostV2/RelatedPostV2';
import EditButton from '../../EditButton/EditButton';
import SidebarLeadForm from '../../LeadForm/SidebarLeadForm/SidebarLeadForm';
import Faq from '../../Faq/Faq';
import ClaimBanner from '../../Banners/ClaimBanner/ClaimBanner';
import BengkelBanner from '../../Banners/BengkelBanner/BengkelBanner';
import CartaxBanner from '../../Banners/CartaxBanner/CartaxBanner';

import { contentHandler } from '../../../lib/contentHandler';

import useResponsive from '../../../utils/hooks/useResponsive';
import { isBengkelPost, hasPostTag } from '../../../utils/verifier';

const PostV2 = ({ post, relatedPosts, ctaTexts }) => {
  const { isDesktop } = useResponsive();

  const [authenticated, setAuthenticated] = useState(false);
  const token = jsCookie.get('token');

  useEffect(() => {
    if (token && !authenticated) {
      setAuthenticated(true);
    }
  }, []);

  const isClaim = hasPostTag('claim', post);
  const isCartax = hasPostTag('cartax', post);
  const isBengkel = isBengkelPost(post);

  const showPostMeta = () => {
    return (
      <div className={styles.post__meta}>
        {post.author && <PostAuthor author={post.author.node} />}
        <span className="ml-1 mr-1">/</span>
        <PostCategory categories={post.categories} />
        <Divider />
        <ReadingTime time={post.readingTime} />
        <Divider />
        <PostDate createdDate={post.date} />
      </div>
    );
  };

  const showSideBanner = () => {
    if (isClaim) return <ClaimBanner />;
    if (isBengkel) return <BengkelBanner />;
    if (isCartax) return <CartaxBanner />;
  };

  return (
    <>
      <EditButton postId={post.databaseId} />
      <div className={styles['single-post__wrapper']}>
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className={classNames(styles['single__post--grid'], 'mb-3')}>
              <div
                className={styles.post}
                itemScope={post.hasFaq}
                itemType={post.hasFaq ? 'https://schema.org/FAQPage' : ''}
              >
                <div className={styles.post__header}>
                  {isDesktop ? '' : showPostMeta()}
                  <h1 className={styles.post__title}>{post.title}</h1>
                  <div className={styles.post__info}>
                    {isDesktop ? showPostMeta() : ''}
                    <SocialShare slug={post.slug} title={post.title} isV2={true} />
                  </div>
                </div>
                <div className={styles['post__featured-image']}>
                  {post.featuredImage && (
                    <img
                      src={post.featuredImage?.node.sourceUrl}
                      alt={post.featuredImage?.node.altText || post.title}
                      width={738}
                      height={416}
                      sizes={post.featuredImage?.node.sizes}
                    />
                  )}
                </div>
                <div className={`content ${styles.post__content}`}>
                  {contentHandler(post.content, post.slug, post.title, post, false, ctaTexts)}
                </div>
                <div className={styles.post__footer}>
                  <PostTag tags={post.tags.nodes} isV2={true} />
                  <SocialShare slug={post.slug} title={post.title} isV2={true} />
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            {isDesktop && (
              <div className={styles.widget__item}>
                <Faq isSidebar={true} categories={post.categories} />
              </div>
            )}
            {isDesktop && showSideBanner()}

            <div className={styles.widget__item}>
              <RelatedPostV2 relatedPosts={relatedPosts} />
            </div>
            <StickyBox className={styles.widget__item_leadform}>
              {isDesktop && <SidebarLeadForm title={post.categories.nodes.leadFormTitle} />}
            </StickyBox>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostV2;
